import React, { useEffect, useState } from "react";
import browser from "web/script/utils/browser";
import userProfiler from "web/script/modules/userprofiler";
import {
    BranchBannerCampaign,
    BannerSize,
    BannerType,
    getBannerCampaign,
} from "web/script/utils/app-banner-campaign";
import analytics from "web/script/analytics/analytics";
import store from "web/redux/store";
import { bannerHidden, bannerVisible, setBannerSize } from "web/redux/ducks/app-download-banner";
import { CampaignRawBranchLink } from "web/script/utils/branch-io";
import SmallAppDownloadBanner from "./small-app-download-banner";

const BRANCH_LINKS = {
    enable_branch_io_feed: CampaignRawBranchLink.Feed,
    enable_branch_io_homepage: CampaignRawBranchLink.Homepage,
    enable_branch_io_is_pdp: CampaignRawBranchLink.ISPDP,
    enable_branch_io_oos_pdp: CampaignRawBranchLink.OOSPDP,
    enable_branch_io_lead_return: CampaignRawBranchLink.LeadReturn,
};

function getBranchBannerCampaign(): BranchBannerCampaign | undefined {
    const branchBannerCampaign = getBannerCampaign(
        analytics.getInitialPageType(),
        analytics.getInitialSubPageType()
    ) as BranchBannerCampaign;

    if (!branchBannerCampaign || branchBannerCampaign.bannerType !== BannerType.Native) {
        return;
    } else {
        branchBannerCampaign.branchLink = BRANCH_LINKS[branchBannerCampaign.flag];
        return branchBannerCampaign;
    }
}

export function AppDownloadBanner(): null | JSX.Element {
    const [isHidden, setIsHidden] = useState(true);
    const [bannerCampaign, setBannerCampaign] = useState<BranchBannerCampaign>();
    const analyticsEventCategory = "app_banner";

    function hideBanner(): void {
        setIsHidden(true);
    }

    function showBanner(): void {
        setIsHidden(false);
    }

    useEffect(() => {
        if (!isHidden && bannerCampaign) {
            store.dispatch(bannerVisible());
            store.dispatch(setBannerSize(bannerCampaign.bannerSize));

            if (!userProfiler.hasAppBannerShown()) {
                userProfiler.saveAppBannerShown();
                analytics.event(analyticsEventCategory, "shown", bannerCampaign.name, true);
            }
        } else {
            store.dispatch(bannerHidden());
        }
    }, [isHidden, bannerCampaign]);

    useEffect(() => {
        const bannerCampaignData = getBranchBannerCampaign();

        if (browser.ios && bannerCampaignData && !userProfiler.hasAppBannerBeenDismissed()) {
            setBannerCampaign(bannerCampaignData);
            showBanner();
        } else {
            hideBanner();
        }
    }, []);

    function onClose(): void {
        analytics.event(
            analyticsEventCategory,
            "dismissed",
            bannerCampaign ? bannerCampaign.name : ""
        );
        hideBanner();

        userProfiler.saveAppBannerDismissed();
    }

    if (isHidden || !bannerCampaign || bannerCampaign.bannerSize !== BannerSize.Small) {
        return null;
    }

    return <SmallAppDownloadBanner bannerCampaign={bannerCampaign} onClose={onClose} />;
}

export default AppDownloadBanner;
